import {h, Fragment} from "preact"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"

import { CATEGORY_RECID } from "../config"

import Toolbar from "./Toolbar"
import SelectedFilters from "./SelectedFilters"
import Products from "./Products"
import BottomToolbar from "./BottomToolbar"
import Skeleton from "./Skeleton"
import NoResults from "./NoResults"

export function CategoryBody({ loading, foundProducts }) {
    return (foundProducts ? (
        <>
            <Toolbar />
            <SelectedFilters />
            <Products />
            <BottomToolbar />
            <nosto-campaign placement={CATEGORY_RECID} id={CATEGORY_RECID} />
        </> 
    ) : loading ? (
        <Skeleton />
    ): (
        <NoResults />
    ))
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    return (foundProducts ? (
        <>
            <Toolbar />
            <SelectedFilters />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    ) : loading ? (
        <Skeleton />
    ) : (
        <NoResults />
    ))
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)

